export default "__VITE_ASSET__BfbyFQn5__"